import React from 'react';
import { useSpotify } from '../../hoc/context/SpotifyContextContainer'

const User = () => {
    const { user, retrievedInfo } = useSpotify()
    const userImg = user.images[0].url;
    const userLink = user.external_urls.spotify;
    const userName = user.display_name;


    return (
        <div className="user">
            <button rel="noreferrer" className="user__link" onClick={() => retrievedInfo(null, null, null)}>
                {/* Welcome! {userName} */}
                <img className="user__img" src={userImg} alt={userName} title={userName}/>
                <h3 className="user__logout">logout</h3>
            </button>
        </div>
    );
}

export default User;
